import { Injectable } from '@angular/core';
import { SicorApiService } from '../SicorService/sicor-api.service';
import { take, tap } from 'rxjs/operators';
import { NotificationGeoAroundRequest } from '../SicorService/RequestObject/NotificationGeoAroundRequest';
import { Geolocation } from '@capacitor/geolocation';


@Injectable({
  providedIn: 'root'
})
export class GeoAroundService {

  constructor(private sicorAPI: SicorApiService) { }

  public async sendNotificationGeoAround(requestParams: NotificationGeoAroundRequest) {
    let success: boolean;
    await (await this.sicorAPI.sendNotificationGeoAroundRequest(requestParams)).pipe(
      take(1),
      tap(
        async res => {
          if (res.resultSet[0] != null && res.resultSet[0].error != null) {
            success = true;
          }
          else {
            success = false;
          }
        }, e => {
          success = null;
        }
      )).toPromise();
      return success;
  }

  async isUserInRange(lat1: number, lon1: number, radius: number) {
    let lat2 = 0;
    let lon2 = 0;
    await Geolocation.getCurrentPosition({ enableHighAccuracy: true, timeout: 1000 }).then(async coordinates => {
      lat2 = coordinates.coords.latitude;
      lon2 = coordinates.coords.longitude;
    }).catch(async err => {
      lat2 = 0;
      lon2=  0;
      return null;
    });
    let R = 6371; // km
    let dLat = this.toRad(lat2-lat1);
    let dLon = this.toRad(lon2-lon1);
    lat1 = this.toRad(lat1);
    lat2 = this.toRad(lat2);

    let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    let d = R * c;

    if (d < (radius/1000)){
      return true;
    } else {
      return false;
    }
  } 

  toRad(Value) 
  {
      return Value * Math.PI / 180;
  }
}
